module.exports = function getResource(label) {
    const resources = {
        itemSubErrorModalTitle: 'Articles de remplacement retirés',
        gotIt: 'Compris'
    };
    return resources[label];
};
